// Main entry point for Vite build
// Import polyfills for older browsers
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// Import config module (generated by Vite plugin)
import 'shopspace.config';

// Import all AngularJS templates (prevents tree-shaking in production)
import 'virtual:angular-templates';

// jQuery, Lodash, Angular core, UI Router, and Restangular are loaded via script tags in index.html
// This ensures they're available synchronously as globals before any plugins load

// Import other Angular dependencies
// angular-ui-bootstrap is loaded via script tag in index.html
import 'angular-loading-bar';
import 'angular-growl-v2';
import 'angular-auto-validate';
import 'ng-tags-input';
import 'angular-ui-calendar';
// fullcalendar is loaded via script tag in index.html (needs lodash and moment globals)
import 'angular-dialog-service';
import 'ng-sortable';
// @flowjs/ng-flow is loaded via script tag in index.html (ng-flow-standalone.js)
import 'angular-i18n/angular-locale_pl';
import 'papaparse';
import 'angular-busy';
import 'angular-elastic';
// jsondiffpatch is imported directly in files that use it
import 'angular-file-saver';
import 'angular-ui-grid';
// angular-translate is loaded via script tag in index.html
import 'angular-ui-ace';
import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/theme-twilight';
import 'ace-builds/src-noconflict/mode-javascript';
// ngmap is loaded via script tag in index.html (needs Angular global)
import 'jschardet';
import 'angular-ui-tree';
import 'angular-ui-sortable';
// moment is loaded via script tag in index.html

// Velocity animations
import Velocity from 'velocity-animate';
window.Velocity = Velocity;

// jQuery plugins (loaded via script tags in index.html to prevent tree-shaking)
// - jquery-hoverintent: extends jQuery with .hoverIntent() method
// - jquery-ui: extends jQuery with UI widgets (.sortable(), .draggable(), etc.)

// Import styles
// Note: Bootstrap CSS is loaded in index.html via link tag to avoid Vite resolution issues
import './app/style.less';
import 'angular-loading-bar/build/loading-bar.css';
import 'angular-growl-v2/build/angular-growl.css';
import 'ng-tags-input/build/ng-tags-input.css';
import 'ng-tags-input/build/ng-tags-input.bootstrap.css';
import 'fullcalendar/dist/fullcalendar.css';
import 'angular-dialog-service/dist/dialogs.css';
import 'ng-sortable/dist/ng-sortable.css';
import 'angular-busy/dist/angular-busy.css';
import 'angular-ui-grid/ui-grid.css';
import 'angular-ui-tree/dist/angular-ui-tree.css';
import 'angular-ui-bootstrap/dist/ui-bootstrap-csp.css';
import 'font-awesome/css/font-awesome.css';
import 'jsondiffpatch/dist/formatters-styles/html.css';
import 'jsondiffpatch/dist/formatters-styles/annotated.css';

// Import configuration module
// import 'virtual:config'; // Commented out - not implemented in current vite.config.js

// Import the main application module FIRST (creates the angular module)
import './app/shopspace-admin.js';

// Import shopspace-service.js BEFORE other modules (defines shopspace.service module)
// This must load before directive-api-service.js, details-service.js, etc.
import './app/main/shopspace-service.js';

// Templates are now loaded via virtual:angular-templates (imported above)
// No need for import.meta.glob here

// Import all other application modules AFTER main module is created
// Use non-eager loading to prevent execution before Angular is ready
// Exclude files that depend on specific parent modules - they are imported by their parent modules to ensure correct load order
const appModules = import.meta.glob([
  './app/**/*.js',
  '!./app/**/*-modal.controller.js',
  '!./app/orders/order-actions.service.js'
], { eager: false });
const componentModules = import.meta.glob('./components/**/*.js', { eager: false });

// Bootstrap Angular application when DOM is ready AND all modules are loaded
$(document).ready(function() {
  // Load all modules first, then bootstrap Angular
  Promise.all([
    ...Object.keys(appModules).map(path => appModules[path]()),
    ...Object.keys(componentModules).map(path => componentModules[path]())
  ]).then(() => {
    console.log('All modules loaded');

    // Flush template queue into $templateCache BEFORE bootstrap
    // Templates must be available before Angular compiles the DOM
    if (window._templateQueue && window._templateQueue.length > 0) {
      try {
        const templateCount = window._templateQueue.length;
        const templates = window._templateQueue.slice(); // Copy the array

        // Register templates in a .run() block BEFORE bootstrapping
        // This ensures templates are available when directives compile
        angular.module('shopspace.admin').config(['$provide', function($provide) {
          $provide.decorator('$templateCache', ['$delegate', function($delegate) {
            templates.forEach(function(template) {
              $delegate.put(template.path, template.content);
            });
            console.log('Registered', templates.length, 'templates from queue via decorator');
            return $delegate;
          }]);
        }]);

        window._templateQueue = [];
        console.log('Queued', templateCount, 'templates for registration before bootstrap');
      } catch (e) {
        console.error('Error registering templates from queue:', e);
      }
    }

    // Now bootstrap Angular with all modules registered and templates loaded
    angular.element(document).ready(function() {
      angular.bootstrap(document, ['shopspace.admin'], {
        strictDi: false
      });
    });
  });
});